import { Mock } from '@interfaces/mock.interface';

export const AppointmentsMock: Mock = {
    key: 'apponitments',
    label: 'Rendez-vous FTTH',
    default: true,
    data: {
        result: {
            returnCode: '200',
            returnMessage: 'Requête traitée avec succès',
        },
        nombreCreneauxDisponibles: 74,
        creneauCourant: {
            debutCreneau: null,
            finCreneau: null,
        },
        items: [
            {
                idCreneau: '08D90EF95904C3D5bcb8',
                debutCreneau: '2021-05-15T14:00:00+0200',
                finCreneau: '2021-05-15T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C3D5bcb8',
                            debutCreneau: '2021-05-15T14:00:00+0200',
                            finCreneau: '2021-05-15T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C719bcb9',
                debutCreneau: '2021-05-17T08:00:00+0200',
                finCreneau: '2021-05-17T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C719bcb9',
                            debutCreneau: '2021-05-17T08:00:00+0200',
                            finCreneau: '2021-05-17T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C745bcba',
                debutCreneau: '2021-05-17T14:00:00+0200',
                finCreneau: '2021-05-17T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C745bcba',
                            debutCreneau: '2021-05-17T14:00:00+0200',
                            finCreneau: '2021-05-17T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C74Dbcbb',
                debutCreneau: '2021-05-18T14:00:00+0200',
                finCreneau: '2021-05-18T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C74Dbcbb',
                            debutCreneau: '2021-05-18T14:00:00+0200',
                            finCreneau: '2021-05-18T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C753bcbc',
                debutCreneau: '2021-05-19T08:00:00+0200',
                finCreneau: '2021-05-19T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C753bcbc',
                            debutCreneau: '2021-05-19T08:00:00+0200',
                            finCreneau: '2021-05-19T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C75Cbcbd',
                debutCreneau: '2021-05-19T14:00:00+0200',
                finCreneau: '2021-05-19T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C75Cbcbd',
                            debutCreneau: '2021-05-19T14:00:00+0200',
                            finCreneau: '2021-05-19T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C763bcbe',
                debutCreneau: '2021-05-20T08:00:00+0200',
                finCreneau: '2021-05-20T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C763bcbe',
                            debutCreneau: '2021-05-20T08:00:00+0200',
                            finCreneau: '2021-05-20T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C769bcbf',
                debutCreneau: '2021-05-20T14:00:00+0200',
                finCreneau: '2021-05-20T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C769bcbf',
                            debutCreneau: '2021-05-20T14:00:00+0200',
                            finCreneau: '2021-05-20T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C76Fbcc0',
                debutCreneau: '2021-05-21T08:00:00+0200',
                finCreneau: '2021-05-21T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C76Fbcc0',
                            debutCreneau: '2021-05-21T08:00:00+0200',
                            finCreneau: '2021-05-21T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C775bcc1',
                debutCreneau: '2021-05-21T14:00:00+0200',
                finCreneau: '2021-05-21T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C775bcc1',
                            debutCreneau: '2021-05-21T14:00:00+0200',
                            finCreneau: '2021-05-21T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C77Bbcc2',
                debutCreneau: '2021-05-22T08:00:00+0200',
                finCreneau: '2021-05-22T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C77Bbcc2',
                            debutCreneau: '2021-05-22T08:00:00+0200',
                            finCreneau: '2021-05-22T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C782bcc3',
                debutCreneau: '2021-05-22T14:00:00+0200',
                finCreneau: '2021-05-22T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C782bcc3',
                            debutCreneau: '2021-05-22T14:00:00+0200',
                            finCreneau: '2021-05-22T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C787bcc4',
                debutCreneau: '2021-05-24T08:00:00+0200',
                finCreneau: '2021-05-24T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C787bcc4',
                            debutCreneau: '2021-05-24T08:00:00+0200',
                            finCreneau: '2021-05-24T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C802bcc5',
                debutCreneau: '2021-05-24T14:00:00+0200',
                finCreneau: '2021-05-24T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C802bcc5',
                            debutCreneau: '2021-05-24T14:00:00+0200',
                            finCreneau: '2021-05-24T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C808bcc6',
                debutCreneau: '2021-05-25T08:00:00+0200',
                finCreneau: '2021-05-25T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C808bcc6',
                            debutCreneau: '2021-05-25T08:00:00+0200',
                            finCreneau: '2021-05-25T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C80Ebcc7',
                debutCreneau: '2021-05-25T14:00:00+0200',
                finCreneau: '2021-05-25T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C80Ebcc7',
                            debutCreneau: '2021-05-25T14:00:00+0200',
                            finCreneau: '2021-05-25T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C814bcc8',
                debutCreneau: '2021-05-26T08:00:00+0200',
                finCreneau: '2021-05-26T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C814bcc8',
                            debutCreneau: '2021-05-26T08:00:00+0200',
                            finCreneau: '2021-05-26T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C81Bbcc9',
                debutCreneau: '2021-05-26T14:00:00+0200',
                finCreneau: '2021-05-26T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C81Bbcc9',
                            debutCreneau: '2021-05-26T14:00:00+0200',
                            finCreneau: '2021-05-26T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C822bcca',
                debutCreneau: '2021-05-27T08:00:00+0200',
                finCreneau: '2021-05-27T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C822bcca',
                            debutCreneau: '2021-05-27T08:00:00+0200',
                            finCreneau: '2021-05-27T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C828bccb',
                debutCreneau: '2021-05-27T14:00:00+0200',
                finCreneau: '2021-05-27T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C828bccb',
                            debutCreneau: '2021-05-27T14:00:00+0200',
                            finCreneau: '2021-05-27T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C82Dbccc',
                debutCreneau: '2021-05-28T08:00:00+0200',
                finCreneau: '2021-05-28T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C82Dbccc',
                            debutCreneau: '2021-05-28T08:00:00+0200',
                            finCreneau: '2021-05-28T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C833bccd',
                debutCreneau: '2021-05-28T14:00:00+0200',
                finCreneau: '2021-05-28T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C833bccd',
                            debutCreneau: '2021-05-28T14:00:00+0200',
                            finCreneau: '2021-05-28T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C839bcce',
                debutCreneau: '2021-05-29T08:00:00+0200',
                finCreneau: '2021-05-29T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C839bcce',
                            debutCreneau: '2021-05-29T08:00:00+0200',
                            finCreneau: '2021-05-29T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C840bccf',
                debutCreneau: '2021-05-29T14:00:00+0200',
                finCreneau: '2021-05-29T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C840bccf',
                            debutCreneau: '2021-05-29T14:00:00+0200',
                            finCreneau: '2021-05-29T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C846bcd0',
                debutCreneau: '2021-05-31T08:00:00+0200',
                finCreneau: '2021-05-31T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C846bcd0',
                            debutCreneau: '2021-05-31T08:00:00+0200',
                            finCreneau: '2021-05-31T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C84Cbcd1',
                debutCreneau: '2021-05-31T14:00:00+0200',
                finCreneau: '2021-05-31T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C84Cbcd1',
                            debutCreneau: '2021-05-31T14:00:00+0200',
                            finCreneau: '2021-05-31T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C852bcd2',
                debutCreneau: '2021-06-01T08:00:00+0200',
                finCreneau: '2021-06-01T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C852bcd2',
                            debutCreneau: '2021-06-01T08:00:00+0200',
                            finCreneau: '2021-06-01T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C859bcd3',
                debutCreneau: '2021-06-01T14:00:00+0200',
                finCreneau: '2021-06-01T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C859bcd3',
                            debutCreneau: '2021-06-01T14:00:00+0200',
                            finCreneau: '2021-06-01T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C85Fbcd4',
                debutCreneau: '2021-06-02T08:00:00+0200',
                finCreneau: '2021-06-02T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C85Fbcd4',
                            debutCreneau: '2021-06-02T08:00:00+0200',
                            finCreneau: '2021-06-02T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C865bcd5',
                debutCreneau: '2021-06-02T14:00:00+0200',
                finCreneau: '2021-06-02T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C865bcd5',
                            debutCreneau: '2021-06-02T14:00:00+0200',
                            finCreneau: '2021-06-02T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C86Bbcd6',
                debutCreneau: '2021-06-03T08:00:00+0200',
                finCreneau: '2021-06-03T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C86Bbcd6',
                            debutCreneau: '2021-06-03T08:00:00+0200',
                            finCreneau: '2021-06-03T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C871bcd7',
                debutCreneau: '2021-06-03T14:00:00+0200',
                finCreneau: '2021-06-03T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C871bcd7',
                            debutCreneau: '2021-06-03T14:00:00+0200',
                            finCreneau: '2021-06-03T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C877bcd8',
                debutCreneau: '2021-06-04T08:00:00+0200',
                finCreneau: '2021-06-04T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C877bcd8',
                            debutCreneau: '2021-06-04T08:00:00+0200',
                            finCreneau: '2021-06-04T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C87Ebcd9',
                debutCreneau: '2021-06-04T14:00:00+0200',
                finCreneau: '2021-06-04T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C87Ebcd9',
                            debutCreneau: '2021-06-04T14:00:00+0200',
                            finCreneau: '2021-06-04T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C884bcda',
                debutCreneau: '2021-06-05T08:00:00+0200',
                finCreneau: '2021-06-05T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C884bcda',
                            debutCreneau: '2021-06-05T08:00:00+0200',
                            finCreneau: '2021-06-05T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C88Abcdb',
                debutCreneau: '2021-06-05T14:00:00+0200',
                finCreneau: '2021-06-05T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C88Abcdb',
                            debutCreneau: '2021-06-05T14:00:00+0200',
                            finCreneau: '2021-06-05T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C8F8bcdc',
                debutCreneau: '2021-06-07T08:00:00+0200',
                finCreneau: '2021-06-07T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C8F8bcdc',
                            debutCreneau: '2021-06-07T08:00:00+0200',
                            finCreneau: '2021-06-07T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C8FFbcdd',
                debutCreneau: '2021-06-07T14:00:00+0200',
                finCreneau: '2021-06-07T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C8FFbcdd',
                            debutCreneau: '2021-06-07T14:00:00+0200',
                            finCreneau: '2021-06-07T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C905bcde',
                debutCreneau: '2021-06-08T08:00:00+0200',
                finCreneau: '2021-06-08T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C905bcde',
                            debutCreneau: '2021-06-08T08:00:00+0200',
                            finCreneau: '2021-06-08T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C90Bbcdf',
                debutCreneau: '2021-06-08T14:00:00+0200',
                finCreneau: '2021-06-08T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C90Bbcdf',
                            debutCreneau: '2021-06-08T14:00:00+0200',
                            finCreneau: '2021-06-08T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C911bce0',
                debutCreneau: '2021-06-09T08:00:00+0200',
                finCreneau: '2021-06-09T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C911bce0',
                            debutCreneau: '2021-06-09T08:00:00+0200',
                            finCreneau: '2021-06-09T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C917bce1',
                debutCreneau: '2021-06-09T14:00:00+0200',
                finCreneau: '2021-06-09T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C917bce1',
                            debutCreneau: '2021-06-09T14:00:00+0200',
                            finCreneau: '2021-06-09T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C91Dbce2',
                debutCreneau: '2021-06-10T08:00:00+0200',
                finCreneau: '2021-06-10T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C91Dbce2',
                            debutCreneau: '2021-06-10T08:00:00+0200',
                            finCreneau: '2021-06-10T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C923bce3',
                debutCreneau: '2021-06-10T14:00:00+0200',
                finCreneau: '2021-06-10T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C923bce3',
                            debutCreneau: '2021-06-10T14:00:00+0200',
                            finCreneau: '2021-06-10T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C929bce4',
                debutCreneau: '2021-06-11T08:00:00+0200',
                finCreneau: '2021-06-11T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C929bce4',
                            debutCreneau: '2021-06-11T08:00:00+0200',
                            finCreneau: '2021-06-11T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C92Fbce5',
                debutCreneau: '2021-06-11T14:00:00+0200',
                finCreneau: '2021-06-11T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C92Fbce5',
                            debutCreneau: '2021-06-11T14:00:00+0200',
                            finCreneau: '2021-06-11T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C935bce6',
                debutCreneau: '2021-06-12T08:00:00+0200',
                finCreneau: '2021-06-12T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C935bce6',
                            debutCreneau: '2021-06-12T08:00:00+0200',
                            finCreneau: '2021-06-12T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C93Bbce7',
                debutCreneau: '2021-06-12T14:00:00+0200',
                finCreneau: '2021-06-12T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C93Bbce7',
                            debutCreneau: '2021-06-12T14:00:00+0200',
                            finCreneau: '2021-06-12T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C941bce8',
                debutCreneau: '2021-06-14T08:00:00+0200',
                finCreneau: '2021-06-14T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C941bce8',
                            debutCreneau: '2021-06-14T08:00:00+0200',
                            finCreneau: '2021-06-14T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C947bce9',
                debutCreneau: '2021-06-14T14:00:00+0200',
                finCreneau: '2021-06-14T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C947bce9',
                            debutCreneau: '2021-06-14T14:00:00+0200',
                            finCreneau: '2021-06-14T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C94Dbcea',
                debutCreneau: '2021-06-15T08:00:00+0200',
                finCreneau: '2021-06-15T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C94Dbcea',
                            debutCreneau: '2021-06-15T08:00:00+0200',
                            finCreneau: '2021-06-15T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C953bceb',
                debutCreneau: '2021-06-15T14:00:00+0200',
                finCreneau: '2021-06-15T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C953bceb',
                            debutCreneau: '2021-06-15T14:00:00+0200',
                            finCreneau: '2021-06-15T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C959bcec',
                debutCreneau: '2021-06-16T08:00:00+0200',
                finCreneau: '2021-06-16T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C959bcec',
                            debutCreneau: '2021-06-16T08:00:00+0200',
                            finCreneau: '2021-06-16T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C960bced',
                debutCreneau: '2021-06-16T14:00:00+0200',
                finCreneau: '2021-06-16T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C960bced',
                            debutCreneau: '2021-06-16T14:00:00+0200',
                            finCreneau: '2021-06-16T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C966bcee',
                debutCreneau: '2021-06-17T08:00:00+0200',
                finCreneau: '2021-06-17T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C966bcee',
                            debutCreneau: '2021-06-17T08:00:00+0200',
                            finCreneau: '2021-06-17T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C96Cbcef',
                debutCreneau: '2021-06-17T14:00:00+0200',
                finCreneau: '2021-06-17T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C96Cbcef',
                            debutCreneau: '2021-06-17T14:00:00+0200',
                            finCreneau: '2021-06-17T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C973bcf0',
                debutCreneau: '2021-06-18T08:00:00+0200',
                finCreneau: '2021-06-18T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C973bcf0',
                            debutCreneau: '2021-06-18T08:00:00+0200',
                            finCreneau: '2021-06-18T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C979bcf1',
                debutCreneau: '2021-06-18T14:00:00+0200',
                finCreneau: '2021-06-18T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C979bcf1',
                            debutCreneau: '2021-06-18T14:00:00+0200',
                            finCreneau: '2021-06-18T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C980bcf2',
                debutCreneau: '2021-06-19T08:00:00+0200',
                finCreneau: '2021-06-19T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C980bcf2',
                            debutCreneau: '2021-06-19T08:00:00+0200',
                            finCreneau: '2021-06-19T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C986bcf3',
                debutCreneau: '2021-06-19T14:00:00+0200',
                finCreneau: '2021-06-19T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C986bcf3',
                            debutCreneau: '2021-06-19T14:00:00+0200',
                            finCreneau: '2021-06-19T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C9F2bcf4',
                debutCreneau: '2021-06-21T08:00:00+0200',
                finCreneau: '2021-06-21T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C9F2bcf4',
                            debutCreneau: '2021-06-21T08:00:00+0200',
                            finCreneau: '2021-06-21T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C9F8bcf5',
                debutCreneau: '2021-06-21T14:00:00+0200',
                finCreneau: '2021-06-21T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C9F8bcf5',
                            debutCreneau: '2021-06-21T14:00:00+0200',
                            finCreneau: '2021-06-21T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904C9FEbcf6',
                debutCreneau: '2021-06-22T08:00:00+0200',
                finCreneau: '2021-06-22T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904C9FEbcf6',
                            debutCreneau: '2021-06-22T08:00:00+0200',
                            finCreneau: '2021-06-22T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA04bcf7',
                debutCreneau: '2021-06-22T14:00:00+0200',
                finCreneau: '2021-06-22T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA04bcf7',
                            debutCreneau: '2021-06-22T14:00:00+0200',
                            finCreneau: '2021-06-22T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA0Bbcf8',
                debutCreneau: '2021-06-23T08:00:00+0200',
                finCreneau: '2021-06-23T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA0Bbcf8',
                            debutCreneau: '2021-06-23T08:00:00+0200',
                            finCreneau: '2021-06-23T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA13bcf9',
                debutCreneau: '2021-06-23T14:00:00+0200',
                finCreneau: '2021-06-23T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA13bcf9',
                            debutCreneau: '2021-06-23T14:00:00+0200',
                            finCreneau: '2021-06-23T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA19bcfa',
                debutCreneau: '2021-06-24T08:00:00+0200',
                finCreneau: '2021-06-24T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA19bcfa',
                            debutCreneau: '2021-06-24T08:00:00+0200',
                            finCreneau: '2021-06-24T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA1Fbcfb',
                debutCreneau: '2021-06-24T14:00:00+0200',
                finCreneau: '2021-06-24T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA1Fbcfb',
                            debutCreneau: '2021-06-24T14:00:00+0200',
                            finCreneau: '2021-06-24T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA25bcfc',
                debutCreneau: '2021-06-25T08:00:00+0200',
                finCreneau: '2021-06-25T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA25bcfc',
                            debutCreneau: '2021-06-25T08:00:00+0200',
                            finCreneau: '2021-06-25T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA2Cbcfd',
                debutCreneau: '2021-06-25T14:00:00+0200',
                finCreneau: '2021-06-25T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA2Cbcfd',
                            debutCreneau: '2021-06-25T14:00:00+0200',
                            finCreneau: '2021-06-25T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA32bcfe',
                debutCreneau: '2021-06-26T08:00:00+0200',
                finCreneau: '2021-06-26T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA32bcfe',
                            debutCreneau: '2021-06-26T08:00:00+0200',
                            finCreneau: '2021-06-26T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA38bcff',
                debutCreneau: '2021-06-26T14:00:00+0200',
                finCreneau: '2021-06-26T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA38bcff',
                            debutCreneau: '2021-06-26T14:00:00+0200',
                            finCreneau: '2021-06-26T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA3Ebd00',
                debutCreneau: '2021-06-28T08:00:00+0200',
                finCreneau: '2021-06-28T12:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA3Ebd00',
                            debutCreneau: '2021-06-28T08:00:00+0200',
                            finCreneau: '2021-06-28T12:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
            {
                idCreneau: '08D90EF95904CA45bd01',
                debutCreneau: '2021-06-28T14:00:00+0200',
                finCreneau: '2021-06-28T18:00:00+0200',
                idPrestataire: 'SOGETREL',
                _actions: {
                    RESERVER: {
                        action: '/rendez-vous/?idContrat=null',
                        method: 'POST',
                        input: {
                            idCreneau: '08D90EF95904CA45bd01',
                            debutCreneau: '2021-06-28T14:00:00+0200',
                            finCreneau: '2021-06-28T18:00:00+0200',
                            idPrestataire: 'SOGETREL',
                            telContactClient: null,
                            natureProduit: 'FTTH',
                            collecte: null,
                        },
                    },
                },
                marge: null,
                codesUI: null,
            },
        ],
        typeCalendrier: 'RAC_STANDARD',
        eligibiliteCreneauxSpecifiques: false,
    },
};
